import React, { Component } from "react";

class CollapseContent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { className, children, ...props } = this.props;
		const style = ["collapse-content-component", !!className ? className : ""].join(" ");

		return (
			<div className={style} {...props}>
				{children}
			</div>
		);
	}
}

export default CollapseContent;
